import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-physical-credential-confirm-dialog',
  templateUrl: './physical-credential-confirm-dialog.component.html',
  styleUrls: ['./physical-credential-confirm-dialog.component.scss'],
})
export class PhysicalCredentialConfirmDialogComponent {
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Input() name!: any;
  @Input() title: any;
  @Input() headingText: any;
  @Input() bodyText: any;
  @Input() footerText: any;
  @Input() confirmBtn: any;
  @Input() cancelBtn: any;
  @Input() isCardActive: any;

  @Output() stepperChange = new EventEmitter<number>();
  @Output() deleteUserEmitter = new EventEmitter<boolean>();
  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;

  constructor() {}

  /**
   * @description navigate back button form previous step
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef.close();
    // this.stepperChange.emit((this.stepper += -1));
  }

  navigateConditionally() {
    this.navigateNext();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    if (this.isCardActive && this.stepper === 0) {
      this.navigateConditionally();
      return;
    }
    if (this.isCardActive && this.stepper === 1) {
      this.closeDialog();
      return;
    }
    this.stepperChange.emit((this.stepper = this.stepper - 1));
  }

  /**
   * @description decrements the stepper value for specific case - opens popup for default modal
   * @returns void
   */
  openDefaultPopup() {
    this.stepperChange.emit((this.stepper = this.stepper - 1));
  }

  /**
   * @description navigate to next screen
   * @returns void
   */
  navigateNext(): void {
    this.stepperChange.emit(this.stepper + 1);
  }

  /**
   * @description emits the value from child to parent method
   * @returns void
   */
  deleteUser(): void {
    this.deleteUserEmitter.next();
  }
}
